import { Img } from "../../components";
import React from "react";
import { Slider } from "../../components/Slider";

export default function LogoRowSection() {
  const logoItems = [
    <div key="logo-1" className="logo-container">
      <Img
        src="images/img_logo_1_Balkrishna_Tyres.png"
        alt="First Logo"
        className="logo"
      />
    </div>,
    <div key="logo-2" className="logo-container">
      <Img
        src="images/img_logo_2_drishti.png"
        alt="Second Logo"
        className="logo"
      />
    </div>,
    <div key="logo-3" className="logo-container">
      <Img
        src="images/img_logo_3_Kennametal_logo.png"
        alt="Third Logo"
        className="logo"
      />
    </div>,
    <div key="logo-4" className="logo-container">
      <Img
        src="images/img_logo_4_IconLabs.webp"
        alt="Fourth Logo"
        className="logo"
      />
    </div>,
    <div key="logo-5" className="logo-container">
      <Img
        src="images/img_logo_5_boldrocchi-group.png"
        alt="Fifth Logo"
        className="logo"
      />
    </div>,
    <div key="logo-6" className="logo-container">
      <Img
        src="images/img_logo_6_classic_moulds_dies.png"
        alt="Sixth Logo"
        className="logo"
      />
    </div>,
    <div key="logo-7" className="logo-container">
      <Img
        src="images/img_logo_7_SINE.jpeg"
        alt="Seventh Logo"
        className="logo"
      />
    </div>,
    <div key="logo-8" className="logo-container">
      <Img
        src="images/img_logo_8_tata-motors.png"
        alt="Eighth Logo"
        className="logo"
      />
    </div>,
  ];

  return (
    <div className="mt-14 mb-5">
      <Slider
        items={logoItems}
        autoWidth={false}
        responsive={{
          0: { items: 3 },
          768: { items: 4 },
          1024: { items: 6 },
        }}
        autoPlay
        autoPlayInterval={3000}
        infinite
        disableButtonsControls
        mouseTracking
        touchTracking
      />
    </div>
  );
}
